import { useMutation, UseMutationResult } from 'react-query';
import { api } from '../api';
import axios from 'axios';
import { useUserContext } from '../providers/UserProvider';

async function createPresignedUrl({ file, id }: { file: File; id: string }): Promise<{ fileName: string }> {
    const { data } = await api.post(`/users/${id}/avatar`);

    // Special use case where we need to use the default axios instance to upload to s3
    await axios.put(data.url, file, {
        headers: {
            'Content-Type': 'image/png',
        },
    });

    return { fileName: data.fileName };
}

export function useUploadUserAvatar(): UseMutationResult<{ fileName: string }, unknown, { file: File }, unknown> {
    const { id } = useUserContext();
    return useMutation((req) => createPresignedUrl({ file: req.file, id }));
}
